module.exports = __webpack_public_path__ + "static/img/tools3-1.42f23ccd.png";